export default __webpack_public_path__ + "static/media/cemredort6.0f841ddc.jpg";